import { getToken } from '@/util/auth' // get token from cookie
import NProgress from 'nprogress' // progress bar
import 'nprogress/nprogress.css' // progress bar style
import router from './router'

NProgress.configure({ showSpinner: false }) // NProgress Configuration

const whiteList = ['/login', '/auth-redirect', '/'] // no redirect whitelist

router.beforeEach(async (to, from, next) => {
  document.title = to.meta.title
  // if (to.redirectedFrom == '/TL') {
  //   next('/login?catid=3420')
  //   return
  // }

  // determine whether the user has logged in
  const hasToken = getToken()

  if (hasToken) {
    if (from.query.catId) {
      to.query.catId = from.query.catId
      next()
    }
    if (to.path === '/login') {
      console.log('token存在并且为login时', to)
      if (to.query.catid) {
        next({ path: '/', query: { ...to.query } })
      } else {
        next({ path: '/' })
      }
    } else {
      // determine whether the user has obtained his permission roles through getInfo
      // const hasHead = store.getters.userInfo
      // console.log(hasHead)
      // if (hasHead) {
      //  next()
      // } else {
      //  try {
      //    await store.dispatch('user/getInfo')
      //    next({ ...to, replace: true })
      //  } catch (error) {
      //    await store.dispatch('user/resetToken')
      //    Message.error(error || 'Has Error')
      //    next(`/login?redirect=${to.path}`)
      //  }
      next()
      // }
    }
  } else {
    console.log('permission:41')
    if (!to.meta.auth) {
      console.log('permission:43')
      next()
    } else {
      console.log('permission:46')
      next({
        path: `/login?redirect=${to.path}`,
        query: to.query
      })
    }
  }
})
